import _ from 'lodash'
import useAsyncWithCache from 'modules/asyncCache/useAsyncWithCache'
import {useState} from 'react'
import {branch, compose, renderNothing} from 'recompose'
import {getResponseItems} from 'views/Shared'


const AsyncSelect = compose(
    branch(
        ({apiInfo}) => _.some([apiInfo], _.isEmpty),
        renderNothing
    )
)(({apiInfo, query, cacheId, children, ...props}) => {
    const [values, setValues] = useState()

    const {response, isLoading} = useAsyncWithCache({
        values,
        cacheId,
        apiInfo,
        query,
        ...props
    })

    return _.isFunction(children)
        ? children({
            isLoading,
            items: getResponseItems(response),
            onSearch: (keyword) => {
                setValues({
                    keyword,
                })
            },
        })
        : children
})

export default AsyncSelect
